module.exports = __webpack_public_path__ + "img/2_164.b1036798.png";